import { render, staticRenderFns } from "./CopyleaksScanButton.vue?vue&type=template&id=4afed736&scoped=true&"
import script from "./CopyleaksScanButton.vue?vue&type=script&lang=js&"
export * from "./CopyleaksScanButton.vue?vue&type=script&lang=js&"
import style0 from "./CopyleaksScanButton.vue?vue&type=style&index=0&id=4afed736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afed736",
  null
  
)

export default component.exports